import React from "react"
import { clearCategories } from "../../../actions/categories";

import { clearActiveMenuItem, setActiveMenuItem, setupMenu, updateMenuRoot } from "../../../actions/menu";
import M from "../../../strings";
import { Layout, Screen, SideBar } from "../../components/layout"
import { getStoreMenu } from "../../../model/menu";
import { HeaderBlockWithBreadcrumbs } from "../../components/common";
import { toast } from "../../../plugins";
import { clearStores, loadTargetQuestionsTree, setStoreTarget, updateStoreTargets, loadStoreTargets } from "../../../actions/stores";
import { StoresStore } from "../../../stores/stores";
import { TreeSelector } from "../../components/treeSelector";
import { connect } from "../../../utils/aj-react";
import _ from "underscore";
import { getLoggedUser } from "../../../api/session";
import { isEmpty } from "../../../framework/utils";


export const TargetQuestionsTreeSelector = connect(TreeSelector).to(StoresStore,
    (state) => ({
        nodes: state.questionNodes,
        inputValues: state.inputValues,
    }),
    (props) => ({
        onInit: (props) => {
            if (!props.manualLoad) {
                //loadCategoriesQuestionsTree(props.categoryIds);
            }
        },
        onDestroy: (props) => {
            if (!props.manualLoad) {
                //clearCategories();
            }
        },
        onUpdate: (props, state) => {
            if (_.isFunction(props.onUpdateQuestions)) {
                this.props.onUpdateQuestions(state.selectedQuestionTemplateIds);
            }
        },
        onInputChange: (id, value) => setStoreTarget(id, value)
    })
)

export class StoreTargetsForm extends Screen {
    componentDidMount() {
        const id = this.props.entityId;

        StoresStore.subscribe(this, state => {
            this.setState({
                targets: state.targets
            }) 
        });

        if (id) {
            updateMenuRoot({
                root: getStoreMenu(id)
            });
            setActiveMenuItem({id: "store.targets"});
        }


        const storeId = this.props.entityId;
        if (!this.isNew()) {
            loadTargetQuestionsTree({storeId});
            loadStoreTargets({storeId});            
        }
    }

    componentWillUnmount() {
        const user = getLoggedUser();

        StoresStore.unsubscribe(this);

        clearStores();

        clearActiveMenuItem();
        
        setupMenu({user});
    }

    isNew() {
        const storeId = this.props.entityId;

        return isEmpty(storeId) || storeId === "new";
    }

    async onSave() {
        const storeId = this.props.entityId;
        if (!this.isNew()) {
            await updateStoreTargets({storeId, targets: this.state.targets});
            toast(M("targetsSaved"));
        }
    }

    onTargetChange(id, value) {
        setStoreTarget(id, value);
    }

    getActions(data) {
        return this.isNew() ? [] : [{
            type: "button",
            text: M("save"),
            tooltip: M("targetsManagement"),
            action: this.onSave.bind(this)
        }];
    }

    getTitle() {
        return M("targets")
    }

    render() {
        const id = this.props.entityId;

        return (
            <Layout>
                <SideBar/>
                <HeaderBlockWithBreadcrumbs title={this.getTitle()} actions={this.getActions()}/>
                {this.isNew() ? (
                    <div
                        className="text-center"
                    >
                        {M("storeTrendsSaveFirst")}
                    </div>
                ) : (<TargetQuestionsTreeSelector 
                    manualLoad={true} 
                    showInput={true} 
                    disableSelection={true} 
                    startsCollapsed={false} 
                    onInputChange={this.onTargetChange.bind(this)}
                    disableToggling={false}
                    inputOnlyOnLeafs={true}
                    />)}
            </Layout>
        )
    }
}